'use client'

import { Icon } from '~/scalis-components/core'

const NavbarNotificationBell = ({ unreadCount }: { unreadCount: number }) => {
  const hasUnreadNotifications = unreadCount > 0

  return (
    <div className='relative border-l border-neutral-00 pl-4'>
      <div className='rounded-md px-1 hover:bg-button-brand-primary-light-hover hover:cursor-pointer'>
        <Icon
          icon='fa-regular fa-bell'
          size={16}
          data-testid='notification-bell'
        />
        {hasUnreadNotifications && (
          <div
            data-testid='unread-indicator'
            className='absolute right-[1px] top-[1px] h-[9px] w-[9px] rounded-full bg-brand-primary-00 border border-brand-primary-light-00 '
          />
        )}
      </div>
    </div>
  )
}

export default NavbarNotificationBell
